import enComponents from 'src/locales/en/components.json'
import zhComponents from 'src/locales/zh/components.json'
import msComponents from 'src/locales/ms/components.json'
import idComponents from 'src/locales/id/components.json'
import deComponents from 'src/locales/de/components.json'
import nlComponents from 'src/locales/nl/components.json'
import enValidations from 'src/locales/en/validations.json'
import zhValidations from 'src/locales/zh/validations.json'
import msValidations from 'src/locales/ms/validations.json'
import idValidations from 'src/locales/id/validations.json'
import deValidations from 'src/locales/de/validations.json'
import nlValidations from 'src/locales/nl/validations.json'
import enConstants from 'src/locales/en/constants.json'
import zhConstants from 'src/locales/zh/constants.json'
import msConstants from 'src/locales/ms/constants.json'
import idConstants from 'src/locales/id/constants.json'
import deConstants from 'src/locales/de/constants.json'
import nlConstants from 'src/locales/nl/constants.json'

const translations: Record<string, Record<string, any>> = {
  en: {
    components: enComponents,
    validations: enValidations,
    constants: enConstants,
  },
  zh: {
    components: zhComponents,
    validations: zhValidations,
    constants: zhConstants,
  },
  ms: {
    components: msComponents,
    validations: msValidations,
    constants: msConstants,
  },
  id: {
    components: idComponents,
    validations: idValidations,
    constants: idConstants,
  },
  de: {
    components: deComponents,
    validations: deValidations,
    constants: deConstants,
  },
  nl: {
    components: nlComponents,
    validations: nlValidations,
    constants: nlConstants,
  },
}

export default translations
